import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { MatTooltipModule } from '@angular/material/tooltip';
import { PlApiModule } from '@common/pl-api.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { RouterModule } from '@angular/router';
import { PLDialogComponent } from '@common/components/pl-dialog';
import { PlDropdownModule } from '@app/common/components/pl-dropdown/pl-dropdown.module';
import {
  PlSearchFilterComponent,
  PlListGridComponent,
  PlTableComponent,
  PlButtonComponent,
  PlInputComponent,
  PlInputFileComponent,
  ModalMessageComponent,
  PlProgressCircleComponent,
  PlCalendarHeaderComponent,
  PlInfoboxComponent,
  PlClientLinkComponent,
  LoadingAnimationComponent,
  PlLocationSelectComponent,
  ClientQuickAddComponent,
} from './components';
import { DateErrorPipe, PlaceholderTextPipe } from './pipes';
import { PlModalService, InternalAdminService } from './services';
import { PlUserService } from './entities';
import { UserProfileService } from './services/user-profile.service';
import {
  PlAccountEffects,
  reducer,
  featureKey,
  PLFeatureFlagEffects,
} from './store';

@NgModule({
  declarations: [
    PlSearchFilterComponent,
    PlLocationSelectComponent,
    PlListGridComponent,
    PlTableComponent,
    PlButtonComponent,
    PlInputFileComponent,
    PlInputComponent, // TODO: Maybe remove in the future only used for story book
    ModalMessageComponent,
    PlProgressCircleComponent,
    PlaceholderTextPipe,
    PlCalendarHeaderComponent,
    PlInfoboxComponent,
    PlClientLinkComponent,
    LoadingAnimationComponent,
    DateErrorPipe,
    PLDialogComponent,
    ClientQuickAddComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatChipsModule,
    MatSelectModule,
    MatMenuModule,
    MatSortModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatDatepickerModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    PlDropdownModule,
    PlApiModule,
    StoreModule.forFeature(featureKey, reducer),
    EffectsModule.forFeature([PlAccountEffects, PLFeatureFlagEffects]),
  ],
  exports: [
    PlSearchFilterComponent,
    PlLocationSelectComponent,
    PlTableComponent,
    PlButtonComponent,
    PlInputFileComponent,
    PlProgressCircleComponent,
    PlaceholderTextPipe,
    PlCalendarHeaderComponent,
    PlInfoboxComponent,
    PlClientLinkComponent,
    LoadingAnimationComponent,
    DateErrorPipe,
    ClientQuickAddComponent,
  ],
  providers: [
    PlModalService,
    PlUserService,
    UserProfileService,
    InternalAdminService,
  ],
})
export class PlCommonModule {}
